// src/components/queryClient.js
import { QueryClient } from '@tanstack/react-query';
import { isAbortError } from '../services/requestUtils';

/**
 * Entity grid list queries (infinite or single-page).
 *
 * Default staleTime is 0, so leaving a route and coming back refetches every
 * cached infinite-query page (e.g. 13 POSTs after scrolling 650 rows).
 * These stay cached until SignalR / save / undo calls invalidateQueries.
 * refetchOnMount:true still refetches if the query was marked stale while unmounted.
 */
export const ENTITY_LIST_QUERY_OPTIONS = {
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: true,
    refetchOnReconnect: false,
};

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Don’t retry on auth failures (token expired) or aborted requests
            retry: (failureCount, error) => {
                if (isAbortError(error)) return false;
                const status = error?.response?.status; // axios error shape
                if (status === 401) return false;
                return failureCount < 2;
            },
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: (failureCount, error) => {
                if (isAbortError(error)) return false;
                const status = error?.response?.status;
                if (status === 401) return false;
                return failureCount < 1;
            },
        },
    },
});
